<div class="container">
  <img src="assets/link-expired.svg" alt="404">
  <p>Oops! It seems like the page you are looking for doesn't exist.</p>
  <button mat-flat-button (click)="goBack()">
    <mat-icon>arrow_back</mat-icon>
    Go back
  </button>
</div>
